import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'

import { RootState } from 'types'

export const useCurrentWorkspaceId = () =>
  useSelector(({ workspace: { currentWorkspaceId } }: RootState) => currentWorkspaceId, isEqual)
